import { useState, useCallback, useEffect } from 'react';
import axiosInstance from '../axios/axiosInstance';

export function useGetPecas() {
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);

  const patch = useCallback(async (id) => {
    try {
      setLoading(true);
      const res = await axiosInstance.get(`pecasInEquipamentosAr/?q=${id}`);
      setResult(res.data);
      setLoading(false);
    } catch (error) {
      if (error.code === 'ERR_NETWORK') {
        setLoading(false);
        return setResult({ error: 'ERR_NETWORK' });
      }
      const err = error.response?.data;
      setLoading(false);
      return setResult({ error: err });
    }
  }, []);

  const reset = () => {
    setResult('');
  };

  return { result, patch, loading, reset };
}

export function usePatchPecas() {
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);

  const resetResult = () => {
    setResult('');
  };

  const patch = useCallback(async (data, id) => {
    try {
      setLoading(true);
      const res = await axiosInstance.patch(`pecasInEquipamentosAr/${id}/`, data);
      setResult(res.data);
      setLoading(false);
    } catch (error) {
      if (error.code === 'ERR_NETWORK') {
        setLoading(false);
        return setResult({ error: 'ERR_NETWORK' });
      }
      const err = error.response?.data;
      setLoading(false);
      return setResult({ error: err });
    }
  }, []);

  return { result, patch, loading, resetResult };
}
